<template>
  <div class="restaurants-module">

    <div class="unit-res-cats d-flex flex-row justify-content-center mx-auto">
      <div v-for="cat in cats" @click="unitCatLoad(cat.id)" :class="`res-cat-item cat${cat.id}`"></div>
    </div>

    <div class="restaurants-main-box">

      <div class="slider">
        <div v-swiper:mySwiper="options">
          <div class="swiper-wrapper">
            <router-link tag="div"
                         v-for="item in slider"
                         :to='`/restaurant/${item.id}`'
                         :key="item.id"
                         class="img-wrapper swiper-slide">
              <img :src="`https://kishoto.ir/dtr/approid/img/${item.image}`" />
              <div class="item-box">
                <div class="item-title-box d-flex flex-row justify-content-between">
                  <h2>{{item.name}}</h2>
                  <div class="star-box">
                    <span>{{item.score}}</span>
                    <star-icon />
                  </div>
                </div>
                <p>{{item.address}}</p>
              </div>
            </router-link>
          </div>

        </div>
        <div class="swiper-pagination"></div>
      </div>

    </div>

  </div>
</template>

<script>

import StarIcon from "vue-material-design-icons/Star.vue";
export default {
  data() {
    return {
        cats:[],
        cat_id:1,
        slider: null,
        options: {
          //slidesPerView: 3,
          //loop: true,
          effect: "coverflow",
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: "auto",
          coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 2,
            slideShadows: true,
          },

          pagination: {
            el: ".swiper-pagination",
            type: 'bullets',
            clickable: true,
          },
        },
    };
  },
  components:{
    StarIcon
  },
  created() {
    this.getUniCatList();
    this.getUnitLists();
  },
  methods: {
    async getUniCatList() {
      const response = await this.$ApiServiceLayer.post("unit_cats");
      if (response.status_code === 200) {
        this.cats = response.list;
      }
    },
    async getUnitLists() {
      let fd = new FormData();
      fd.append("cat_id",this.cat_id);
      fd.append("page",1);
      const response = await this.$ApiServiceLayer.post("unit_list",fd);
      if (response.status_code === 200) {
        this.slider = response.list;
      }
    },
    unitCatLoad(id){
      this.cat_id = id;

      this.$swal.fire({
        title: 'کمی منتظر بمانید',
        //html: 'لطفا برای دریافت پیامک اندکی صبر کنید',
        timer: 1000,
        timerProgressBar: true,
        didOpen: () => {
          this.$swal.showLoading()
          /* timerInterval = setInterval(() => {
             const content = Swal.getContent()
             if (content) {
               const b = content.querySelector('b')
               if (b) {
                 b.textContent = Swal.getTimerLeft()
               }
             }
           }, 100)*/
        },
        willClose: () => {
          //clearInterval(timerInterval)
        }
      }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.dismiss === this.$swal.DismissReason.timer) {
          console.log('I was closed by the timer')
        }
      });
      setTimeout(()=>{
        this.getUnitLists();
      },1000);
    }
  },
};
</script>

<style lang="scss" scoped>
.restaurants-module {
  width: 100%;
  min-height: 100vh;
  background-image: url("~@/assets/img/bg/listcat_back1.jpg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 0px;
  direction: rtl;

  .unit-res-cats{
      width: 91%;
      background: #424242ad;
      padding: 7px;
      border-radius: 18px;
      margin-bottom: 50px;
    .res-cat-item{
        margin-left: 5px;
    }
    .cat1{
      width: 40%;
      height: 100px;
      background-image: url("~@/assets/img/restaurants/resturant.png");
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
    }
    .cat2{
      width: 40%;
      height: 100px;
      background-image: url("~@/assets/img/restaurants/fastfood.png");
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
    }
    .cat3{
      width: 40%;
      height: 100px;
      background-image: url("~@/assets/img/restaurants/daryaee.png");
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
    }
    .cat4{
      width: 40%;
      height: 100px;
      background-image: url("~@/assets/img/restaurants/coffeshop.png");
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }


  .slider {
    width: 100%;
    height: 200px;
    padding: 19px;
    .swiper-container{
      .swiper-wrapper {
        width: 100% !important;
        height: 100%;
        .swiper-slide {
          width: 100% !important;
          padding: 12px;
          border-radius: 26px;
          background: #ffffff;

          img {
            width: 100%;
            height: 244px;
            border-radius: 20px;
          }

          .item-box{
            margin-top: 10px;
            .item-title-box{
              .star-box {
                color: #ffca28;
                font-size: 20px;
              }
            }
            p{
              margin-bottom: 0px;
            }
          }
        }
        .swiper-slide-active{
          width: 100% !important;
        }

       /* .swiper-slide-duplicate-prev,.swiper-slide-duplicate-next {
          position: absolute;
          z-index: -3;
        }*/
      }
    }
    .swiper-pagination{
      right: 0;
      left: 0;
      background: white;
      width: 53%;
      margin: 0 auto;
      margin-top: 11px;
      border-radius: 11px;
      padding: 5px;
    }

  }
}
</style>
